var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33398 11H7.66732V9.66668H6.33398V11ZM7.00065 0.333344C3.32065 0.333344 0.333984 3.32001 0.333984 7.00001C0.333984 10.68 3.32065 13.6667 7.00065 13.6667C10.6807 13.6667 13.6673 10.68 13.6673 7.00001C13.6673 3.32001 10.6807 0.333344 7.00065 0.333344ZM7.00065 12.3333C4.06065 12.3333 1.66732 9.94001 1.66732 7.00001C1.66732 4.06001 4.06065 1.66668 7.00065 1.66668C9.94065 1.66668 12.334 4.06001 12.334 7.00001C12.334 9.94001 9.94065 12.3333 7.00065 12.3333ZM7.00065 3.00001C5.52732 3.00001 4.33398 4.19334 4.33398 5.66668H5.66732C5.66732 4.93334 6.26732 4.33334 7.00065 4.33334C7.73398 4.33334 8.33398 4.93334 8.33398 5.66668C8.33398 7.00001 6.33398 6.83334 6.33398 9.00001H7.66732C7.66732 7.50001 9.66732 7.33334 9.66732 5.66668C9.66732 4.19334 8.47398 3.00001 7.00065 3.00001Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionCircle);
export default __webpack_public_path__ + "static/media/questionCircle.9f970b144115abed1aa59fe5db00c1eb.svg";
export { ForwardRef as ReactComponent };